import styled from 'styled-components';
import { List } from 'antd';

export const StyledListItem = styled(List.Item)`
  &:hover {
    background-color: #fafafa;
    margin-left: -24px;
    margin-right: -24px;
    padding-left: 24px;
    padding-right: 24px;
  }
`;
